import * as React from 'react';
import * as Redux from 'react-redux';
import { Grid, Typography } from '@mui/material';
import { Modal } from '../../../components';
import ListadoTiposDocumentos from './components/ListadoTiposDocumentos';
import FormTiposDocumentos from './components/FormTiposDocumentos';
import {
  getAllTiposDocumentosAction,
  setActivoTiposDocumentosAction,
} from './TiposDocumentosAction';
import BotonNuevoComponent from '../../entidades/components/BotonNuevo';
import { checkRootAccess } from '../../modulos/modules.helpers';

const TiposDocumentosView = () => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const tiposDocumentosStore = Redux.useSelector(
    (state) => state.tiposDocumentos
  );

  const loginStore = Redux.useSelector((state) => state.login);
  checkRootAccess(loginStore);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonNuevoComponent
          click={async () => {
            await setActivoTiposDocumentosAction(dispatch, null);
            setOpenModalForm(true);
          }}
          azul
          mr={2}
        />
        {tiposDocumentosStore.all.length > 0 ? (
          <BotonNuevoComponent
            click={async () => {
              await setActivoTiposDocumentosAction(dispatch, null);
              await getAllTiposDocumentosAction(
                dispatch,
                entidadesStore.activo.id
              );
            }}
            disabled={tiposDocumentosStore.loadingGetAll}
            white
            text={
              tiposDocumentosStore.loadingGetAll
                ? 'Actualizando...'
                : 'Actualizar'
            }
          />
        ) : null}
      </Grid>
      <Grid item md={12}>
        <ListadoTiposDocumentos
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </Grid>
      <Modal
        id="modalFormTiposDocumentos"
        title={`${
          tiposDocumentosStore.activo ? 'Editar' : 'Nuevo'
        } tipo de documento`}
        open={openModalForm}
        maxWidth="sm"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        {tiposDocumentosStore.activo ? (
          <Typography variant="h6">
            {tiposDocumentosStore.activo.nombres}{' '}
            {tiposDocumentosStore.activo.apellidos}
          </Typography>
        ) : null}
        <FormTiposDocumentos
          activo={tiposDocumentosStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </Modal>
    </Grid>
  );
};

export default TiposDocumentosView;
